import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function BusinessModel() {
  return <Section background="ivory" data-id="element-2">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-3">
        <FadeIn data-id="element-4">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-5">
            A Multi-Layered Revenue Engine
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-6">
            A sustainable, scalable model designed to capture value across the
            entire wellness ecosystem.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7">
        {/* Consumer */}
        <FadeIn delay={100} data-id="element-8">
          <div className="bg-white p-10 rounded-3xl border border-purple-200 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-9">
            <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-6" data-id="element-10">
              Consumer (B2C)
            </div>
            <div className="mb-8 flex-grow" data-id="element-11">
              <div className="mb-6" data-id="element-12">
                <div className="text-2xl font-serif text-charcoal mb-1" data-id="element-13">
                  Free Membership
                </div>
                <div className="text-sm text-charcoal/60" data-id="element-14">
                  Entry layer access
                </div>
              </div>
              <div data-id="element-15">
                <div className="flex items-baseline mb-1" data-id="element-16">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-17">
                    $9.99
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-18">/mo</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium mb-2" data-id="element-19">
                  Premium Tier
                </div>
                <ul className="space-y-2 text-sm text-charcoal/60" data-id="element-20">
                  <li data-id="element-21">• AI wellness plans</li>
                  <li data-id="element-22">• Advanced analytics</li>
                  <li data-id="element-23">• Priority booking access</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Practitioner */}
        <FadeIn delay={300} data-id="element-24">
          <div className="bg-purple-100/50 p-10 rounded-3xl border border-purple-300 h-full flex flex-col relative overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-25">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-200/30 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-26"></div>
            <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-6 relative z-10" data-id="element-27">
              Practitioners (B2P)
            </div>
            <div className="mb-8 flex-grow relative z-10" data-id="element-28">
              <div className="mb-6" data-id="element-29">
                <div className="flex items-baseline mb-1" data-id="element-30">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-31">
                    $399
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-32">/yr</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium" data-id="element-33">
                  Individual Practice
                </div>
              </div>
              <div data-id="element-34">
                <div className="flex items-baseline mb-1" data-id="element-35">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-36">
                    $2,550
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-37">/yr</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium mb-2" data-id="element-38">
                  Group Practices
                </div>
                <ul className="space-y-2 text-sm text-charcoal/60" data-id="element-39">
                  <li data-id="element-40">• Practice management tools</li>
                  <li data-id="element-41">• Client analytics</li>
                  <li data-id="element-42">• Premium client acquisition</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Enterprise */}
        <FadeIn delay={500} data-id="element-43">
          <div className="bg-charcoal p-10 rounded-3xl border border-charcoal h-full flex flex-col text-ivory transition-all duration-300 hover:shadow-xl hover:shadow-charcoal/30" data-id="element-44">
            <div className="text-sm uppercase tracking-widest text-purple-400 font-semibold mb-6" data-id="element-45">
              Enterprise (B2B)
            </div>
            <div className="mb-8 flex-grow" data-id="element-46">
              <div className="mb-6" data-id="element-47">
                <div className="flex items-baseline mb-1" data-id="element-48">
                  <span className="text-3xl font-serif text-ivory" data-id="element-49">$3.99</span>
                  <span className="text-ivory/50 ml-1" data-id="element-50">/user/mo</span>
                </div>
                <div className="text-sm text-ivory/80 font-medium mb-2" data-id="element-51">
                  Corporate Wellness
                </div>
                <ul className="space-y-2 text-sm text-ivory/60" data-id="element-52">
                  <li data-id="element-53">• Employee wellness access</li>
                  <li data-id="element-54">• Aggregated analytics dashboards</li>
                  <li data-id="element-55">• Workforce health insights</li>
                  <li data-id="element-56">• Dedicated account management</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}